/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Customer Content API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    UserAgreementResponse,
    UserAgreementResponseFromJSON,
    UserAgreementResponseFromJSONTyped,
    UserAgreementResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedAgreementList
 */
export interface PaginatedAgreementList {
    /**
     * 
     * @type {Pagination}
     * @memberof PaginatedAgreementList
     */
    pagination: Pagination;
    /**
     * 
     * @type {Array<UserAgreementResponse>}
     * @memberof PaginatedAgreementList
     */
    data?: Array<UserAgreementResponse>;
}

export function PaginatedAgreementListFromJSON(json: any): PaginatedAgreementList {
    return PaginatedAgreementListFromJSONTyped(json, false);
}

export function PaginatedAgreementListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedAgreementList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pagination': PaginationFromJSON(json['pagination']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserAgreementResponseFromJSON)),
    };
}

export function PaginatedAgreementListToJSON(value?: PaginatedAgreementList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pagination': PaginationToJSON(value.pagination),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserAgreementResponseToJSON)),
    };
}


